const PaymentGateways = {
  ZOOP: 1,
  CIELO: 2,
  STRIPE: 3,
  MP: 4
};

export default PaymentGateways;
